import { render, staticRenderFns } from "./updateFolder.vue?vue&type=template&id=9727949c&"
import script from "./updateFolder.vue?vue&type=script&lang=js&"
export * from "./updateFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports